import api from './api';

// Categories
export const getCategories = (includeInactive = false) => 
  api.get(`/equipment/categories${includeInactive ? '?includeInactive=true' : ''}`);

export const getCategoryById = (id) => 
  api.get(`/equipment/categories/${id}`);

export const createCategory = (data) => 
  api.post('/equipment/categories', data);

export const updateCategory = (id, data) => 
  api.put(`/equipment/categories/${id}`, data);

export const deleteCategory = (id) => 
  api.delete(`/equipment/categories/${id}`);

// Subcategories
export const getSubcategories = (categoryId = null, includeInactive = false) => {
  const params = new URLSearchParams();
  if (categoryId) params.append('categoryId', categoryId);
  if (includeInactive) params.append('includeInactive', 'true');
  const query = params.toString();
  return api.get(`/equipment/subcategories${query ? '?' + query : ''}`);
};

export const getSubcategoryById = (id) => 
  api.get(`/equipment/subcategories/${id}`);

export const createSubcategory = (data) => 
  api.post('/equipment/subcategories', data);

export const updateSubcategory = (id, data) => 
  api.put(`/equipment/subcategories/${id}`, data);

// Items
export const getItems = (subcategoryId = null, status = null, includeInactive = false) => {
  const params = new URLSearchParams();
  if (subcategoryId) params.append('subcategoryId', subcategoryId);
  if (status) params.append('status', status);
  if (includeInactive) params.append('includeInactive', 'true');
  const query = params.toString();
  return api.get(`/equipment/items${query ? '?' + query : ''}`);
};

export const getAvailableItems = (subcategoryId = null) => {
  const query = subcategoryId ? `?subcategoryId=${subcategoryId}` : '';
  return api.get(`/equipment/items/available${query}`);
};

export const getItemById = (id) => 
  api.get(`/equipment/items/${id}`);

export const createItem = (data) => 
  api.post('/equipment/items', data);

export const updateItem = (id, data) => 
  api.put(`/equipment/items/${id}`, data);

// Requests
export const getMyRequests = () => 
  api.get('/equipment/requests/my');

export const getPendingApproval = () => 
  api.get('/equipment/requests/pending-approval');

export const getAllRequests = (status = null, employeeId = null) => {
  const params = new URLSearchParams();
  if (status) params.append('status', status);
  if (employeeId) params.append('employeeId', employeeId);
  const query = params.toString() ? `?${params.toString()}` : '';
  return api.get(`/equipment/requests${query}`);
};

export const getAll = getAllRequests; // alias

export const getRequestById = (id) =>
  api.get(`/equipment/requests/${id}`);

export const deleteRequest = (id) =>
  api.delete(`/equipment/requests/${id}`);

export const createRequest = (data) => 
  api.post('/equipment/requests', data);

export const approveDM = (id, comments = null) => 
  api.post(`/equipment/requests/${id}/approve-dm`, { comments });

export const approveBoard = (id, comments = null) => 
  api.post(`/equipment/requests/${id}/approve-board`, { comments });

export const rejectRequest = (id, reason) => 
  api.post(`/equipment/requests/${id}/reject`, { reason });

export const orderEquipment = (id, data) => 
  api.post(`/equipment/requests/${id}/order`, data);

export const fulfillRequest = (id, data) => 
  api.post(`/equipment/requests/${id}/fulfill`, data);

// Assignments
export const getMyAssignments = (categoryId = null) => {
  const query = categoryId ? `?categoryId=${categoryId}` : '';
  return api.get(`/equipment/assignments/my${query}`);
};

export const updateMyEquipment = (assignmentId, data) =>
  api.patch(`/equipment/assignments/my/${assignmentId}`, data);

export const getExitChecklist = (employeeId) =>
  api.get(`/equipment/assignments/exit-checklist/${employeeId}`);

export const processReturn = (assignmentId, notes = null) =>
  api.post(`/equipment/assignments/${assignmentId}/return`, { notes });

export const getEmployeeAssignments = (employeeId, includeReturned = false) =>
  api.get(`/equipment/assignments/employee/${employeeId}?includeReturned=${includeReturned}`);

// Admin Assignments
export const getAllAssignments = ({ departmentId, categoryId, includeReturned } = {}) => {
  const params = new URLSearchParams();
  if (departmentId) params.append('departmentId', departmentId);
  if (categoryId) params.append('categoryId', categoryId);
  if (includeReturned) params.append('includeReturned', 'true');
  const query = params.toString();
  return api.get(`/equipment/assignments${query ? '?' + query : ''}`);
};

export const getAssignmentHistory = (employeeId) =>
  api.get(`/equipment/assignments/history/${employeeId}`);

export const assignEquipment = (data) =>
  api.post('/equipment/assignments', data);

export const updateAssignment = (assignmentId, data) =>
  api.put(`/equipment/assignments/${assignmentId}`, data);

export const revokeAssignment = (assignmentId, reason = null) =>
  api.post(`/equipment/assignments/${assignmentId}/return`, { notes: reason });

export default {
  getCategories,
  getCategoryById,
  createCategory,
  updateCategory,
  deleteCategory,
  getSubcategories,
  getSubcategoryById,
  createSubcategory,
  updateSubcategory,
  getItems,
  getAvailableItems,
  getItemById,
  createItem,
  updateItem,
  getMyRequests,
  getPendingApproval,
  getAllRequests,
  getAll,
  getRequestById,
  createRequest,
  deleteRequest,
  approveDM,
  approveBoard,
  rejectRequest,
  orderEquipment,
  fulfillRequest,
  getMyAssignments,
  updateMyEquipment,
  getExitChecklist,
  processReturn,
  getEmployeeAssignments,
  getAllAssignments,
  getAssignmentHistory,
  assignEquipment,
  updateAssignment,
  revokeAssignment
};

